import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const LiveBirthsMothersAge = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();


    return (
        <SimpleBars
            title={'Nascidos vivos segundo a idade da mãe'}
            horizontal={false}
            subtitles={chartData?.liveBirthsMothersAge?.map((item) => item.description)}
            values={chartData?.liveBirthsMothersAge?.map((item) => item.total  ||  0)}
            
        />
    );
};
